// extracted by mini-css-extract-plugin
module.exports = {"automaticMessageContainer":"NewStockingParameterForm_automaticMessageContainer__WNUuo","informationIcon":"NewStockingParameterForm_informationIcon__3kBDp"};